var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataReady)?_c('router-view'):(!_vm.dataReady)?_c('div',{staticClass:"loaderscreen"},[_c('div',{staticClass:"loader buzz"}),(_vm.message != '' )?_c('div',{staticClass:"loadingmessage"},[_vm._v(_vm._s(_vm.message))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }